module.exports = __webpack_public_path__ + "img/zy_banner01.e019352a.jpg";